import type { PublicUser } from '@giftsay/types';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthState {
  status: AuthStatus;
  user: PublicUser | null;
}

const initialState: AuthState = {
  status: 'loading',
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    /** A Firebase session exists but the portal profile is still being fetched. */
    setAuthLoading(state) {
      state.status = 'loading';
    },
    setAuthenticatedUser(state, action: PayloadAction<PublicUser>) {
      state.status = 'authenticated';
      state.user = action.payload;
    },
    setUnauthenticated(state) {
      state.status = 'unauthenticated';
      state.user = null;
    },
  },
});

export const { setAuthLoading, setAuthenticatedUser, setUnauthenticated } = authSlice.actions;
export const authReducer = authSlice.reducer;
